import { UploadFile } from '@ukpostbox/frontend-framework';
import { Controller, useFormContext } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React from 'react';

type SendsFileControlType = {
	name: string;
	multiFile?: boolean;
	reset?: any;
};

function SendsFileControl(props: SendsFileControlType) {
	const { control, getValues } = useFormContext();

	return (
		<Controller
			control={control}
			name={props.name}
			rules={{ required: true }}
			render={({ field, fieldState }) => (
				<UploadFile
					name='File Control'
					onError={(e) => null}
					onChange={(e: any) => field.onChange(e)}
					acceptsFileExtension={['.pdf']}
					extensionDisplayValue='PDF'
					reset={props.reset}
					description={props.multiFile ? "Select up to 1000 PDF's to send" : 'Select a single PDF to send'}
					maxFiles={props.multiFile ? 1000 : 1}
					allowDuplicateSelection={props.multiFile}
				/>
			)}
		/>
	);
}

export { SendsFileControl };
